import { useState, useEffect } from 'react'
import { useApolloClient, ApolloQueryResult } from '@apollo/client'
import Head from 'next/head'
import IpoContent from 'components/ipos'
import {
  IpoContentDocument,
  IpoCommentsDocument,
} from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { parseCookies, setCookie } from 'nookies'
import { countComments } from 'shared/util'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const Ipo = (props) => {
  const apolloClient = useApolloClient()
  const { data: propsData } = props
  const [data, setData] = useState(propsData)
  const {
    all_brokers: allBrokers,
    ipo,
    all_calculators: navCalculators,
    all_pages: allPages,
  } = data
  const ipoData = ipo.data[0]
  useEffect(() => {
    apolloClient
      .query({
        query: IpoCommentsDocument,
        variables: {
          relation: `api::ipo.ipo:${data.ipo.data[0].id}`,
          sort: 'createdAt:desc',
        },
      })
      .then((res: ApolloQueryResult<any>) => {
        if (
          countComments(res.data.plugin_comments) !==
          countComments(data.ipo.data[0].attributes.plugin_comments)
        ) {
          data.ipo.data[0].attributes.plugin_comments = res.data.plugin_comments
          setData(data)
        }
      })
    // handlePageLoad(apolloClient)
    const cookies = parseCookies()
    if (!cookies.country) {
      setCookie(null, 'country', 'us', {
        path: ['/'], // cookie path
      })
    }
  }, [])

  const description = () =>
    `A Personal Finance FAQ portal for India, Canada & USA investors. Financial education hub sharing broker
reviews, stock market queries, trading & investment software and apps.`
  return (
    <ApplicationLayout
      allBrokers={allBrokers.data}
      navCalculators={navCalculators.data}
      allPages={allPages.data}
    >
      <Head>
        <title>IPOs - Fintrakk</title>
        <meta name="description" content={description()} />
      </Head>
      <IpoContent ipoData={ipoData} />
    </ApplicationLayout>
  )
}

export async function getServerSideProps({ params }) {
  const apolloClient = initializeApollo()
  const { slug } = params
  const data = await apolloClient.query({
    query: IpoContentDocument,
    variables: { slug },
  })
  return addApolloState(apolloClient, {
    props: data,
  })
}

export default Ipo
